"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_1 = require("react");
var isMobile_1 = tslib_1.__importDefault(require("rc-util/lib/isMobile"));
var Mask_1 = tslib_1.__importDefault(require("./Mask"));
var MobilePopupInner_1 = tslib_1.__importDefault(require("./MobilePopupInner"));
var PopupInner_1 = tslib_1.__importDefault(require("./PopupInner"));
var Popup = React.forwardRef(function (_a, ref) {
    var visible = _a.visible, mobile = _a.mobile, props = tslib_1.__rest(_a, ["visible", "mobile"]);
    var _b = tslib_1.__read((0, react_1.useState)(visible), 2), innerVisible = _b[0], serInnerVisible = _b[1];
    var _c = tslib_1.__read((0, react_1.useState)(false), 2), inMobile = _c[0], setInMobile = _c[1];
    var cloneProps = tslib_1.__assign(tslib_1.__assign({}, props), { visible: innerVisible });
    // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, react_1.useEffect)(function () {
        serInnerVisible(visible);
        if (visible && mobile) {
            setInMobile((0, isMobile_1.default)());
        }
    }, [visible, mobile]);
    var popupNode = inMobile ? (React.createElement(MobilePopupInner_1.default, tslib_1.__assign({}, cloneProps, { mobile: mobile, ref: ref }))) : (React.createElement(PopupInner_1.default, tslib_1.__assign({}, cloneProps, { ref: ref })));
    // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return (React.createElement("div", null,
        React.createElement(Mask_1.default, tslib_1.__assign({}, cloneProps)),
        popupNode));
});
Popup.displayName = 'Popup';
exports.default = Popup;
//# sourceMappingURL=index.js.map